__turbopack_context__.v({
  "root": "EmptyChatView-module-scss-module__cSY7ga__root",
});
